"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CountryFilter model module.
 * @module model/CountryFilter
 * @version 1.1.3-alpha.1
 */
class CountryFilter {
  /**
   * Constructs a new <code>CountryFilter</code>.
   * @alias module:model/CountryFilter
   */
  constructor() {
    CountryFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CountryFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CountryFilter} obj Optional instance to populate.
   * @return {module:model/CountryFilter} The populated <code>CountryFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CountryFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('available_for_entity_id')) {
        obj['available_for_entity_id'] = _ApiClient.default.convertToType(data['available_for_entity_id'], 'String');
      }
      if (data.hasOwnProperty('with_content')) {
        obj['with_content'] = _ApiClient.default.convertToType(data['with_content'], 'Boolean');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CountryFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CountryFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['available_for_entity_id'] && !(typeof data['available_for_entity_id'] === 'string' || data['available_for_entity_id'] instanceof String)) {
      throw new Error("Expected the field `available_for_entity_id` to be a primitive type in the JSON string but got " + data['available_for_entity_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
CountryFilter.prototype['id'] = undefined;

/**
 * @member {String} available_for_entity_id
 */
CountryFilter.prototype['available_for_entity_id'] = undefined;

/**
 * @member {Boolean} with_content
 */
CountryFilter.prototype['with_content'] = undefined;

/**
 * @member {String} q
 */
CountryFilter.prototype['q'] = undefined;
var _default = exports.default = CountryFilter;